export default {"PACKAGE_VERSION": "2.1.199696.0 (74aa5adb)","UI_THEME": "polaris"}